import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { useAdminData } from '../../contexts/AdminDataContext';
interface SessionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  session?: any;
}
export function SessionModal({
  isOpen,
  onClose,
  onSave,
  session
}: SessionModalProps) {
  const {
    locations,
    classTypes
  } = useAdminData();
  const [formData, setFormData] = useState({
    class_type_id: session?.class_type_id || '',
    location_id: session?.location_id || '',
    session_date: session?.session_date || '',
    start_time: session?.start_time || '',
    capacity: session?.capacity || 12,
    zoom_link: session?.zoom_link || '',
    notes: session?.notes || ''
  });
  useEffect(() => {
    if (isOpen) {
      setFormData({
        class_type_id: session?.class_type_id || '',
        location_id: session?.location_id || '',
        session_date: session?.session_date || '',
        start_time: session?.start_time || '',
        capacity: session?.capacity || 12,
        zoom_link: session?.zoom_link || '',
        notes: session?.notes || ''
      });
    }
  }, [isOpen, session]);
  if (!isOpen) return null;
  const selectedClassType = classTypes.find(ct => ct.id === formData.class_type_id);
  const isVirtual = selectedClassType?.modality === 'virtual';
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Add names for display purposes
    const locationName = isVirtual ? 'Virtual' : locations.find(l => l.id === formData.location_id)?.name || '';
    const className = selectedClassType?.name || '';
    onSave({
      ...formData,
      class_name: className,
      location_name: locationName
    });
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-earth/50 backdrop-blur-sm" data-id="element-596">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.95
    }} className="bg-white rounded-3xl shadow-xl w-full max-w-lg overflow-hidden flex flex-col max-h-[90vh]" data-id="element-597">
        <div className="p-6 border-b border-mist flex justify-between items-center bg-sand/30" data-id="element-598">
          <h2 className="font-display text-2xl font-bold text-earth" data-id="element-599">
            {session ? 'Editar Sesión' : 'Nueva Sesión'}
          </h2>
          <button onClick={onClose} className="text-stone hover:text-earth p-2 rounded-full hover:bg-white transition-colors" data-id="element-600">
            <X size={20} data-id="element-601" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto flex-1" data-id="element-602">
          <form id="session-form" onSubmit={handleSubmit} className="space-y-5" data-id="element-603">
            <div data-id="element-604">
              <label className="block text-sm font-semibold text-earth mb-2" data-id="element-605">
                Tipo de Clase *
              </label>
              <select required value={formData.class_type_id} onChange={e => setFormData({
              ...formData,
              class_type_id: e.target.value
            })} className="w-full p-3 border-2 border-mist rounded-xl text-sm outline-none focus:border-sage focus:ring-4 focus:ring-sage/10 bg-white" data-id="element-606">
                <option value="" data-id="element-607">Selecciona un tipo...</option>
                {classTypes.map(ct => <option key={ct.id} value={ct.id} data-id="element-608">
                    {ct.name} (${ct.price} USD)
                  </option>)}
              </select>
            </div>

            {!isVirtual && <div data-id="element-609">
                <label className="block text-sm font-semibold text-earth mb-2" data-id="element-610">
                  Ubicación *
                </label>
                <select required={!isVirtual} value={formData.location_id} onChange={e => setFormData({
              ...formData,
              location_id: e.target.value
            })} className="w-full p-3 border-2 border-mist rounded-xl text-sm outline-none focus:border-sage focus:ring-4 focus:ring-sage/10 bg-white" data-id="element-611">
                  <option value="" data-id="element-612">Selecciona ubicación...</option>
                  {locations.map(loc => <option key={loc.id} value={loc.id} data-id="element-613">
                      {loc.name}
                    </option>)}
                </select>
              </div>}

            {isVirtual && <div data-id="element-614">
                <label className="block text-sm font-semibold text-earth mb-2" data-id="element-615">
                  Link de Zoom *
                </label>
                <input type="url" required={isVirtual} value={formData.zoom_link} onChange={e => setFormData({
              ...formData,
              zoom_link: e.target.value
            })} placeholder="https://zoom.us/j/..." className="w-full p-3 border-2 border-mist rounded-xl text-sm outline-none focus:border-sage focus:ring-4 focus:ring-sage/10" data-id="element-616" />
              </div>}

            <div className="grid grid-cols-2 gap-4" data-id="element-617">
              <div data-id="element-618">
                <label className="block text-sm font-semibold text-earth mb-2" data-id="element-619">
                  Fecha *
                </label>
                <input type="date" required value={formData.session_date} onChange={e => setFormData({
                ...formData,
                session_date: e.target.value
              })} className="w-full p-3 border-2 border-mist rounded-xl text-sm outline-none focus:border-sage focus:ring-4 focus:ring-sage/10" data-id="element-620" />
              </div>
              <div data-id="element-621">
                <label className="block text-sm font-semibold text-earth mb-2" data-id="element-622">
                  Hora *
                </label>
                <input type="time" required value={formData.start_time} onChange={e => setFormData({
                ...formData,
                start_time: e.target.value
              })} className="w-full p-3 border-2 border-mist rounded-xl text-sm outline-none focus:border-sage focus:ring-4 focus:ring-sage/10" data-id="element-623" />
              </div>
            </div>

            <div data-id="element-624">
              <label className="block text-sm font-semibold text-earth mb-2" data-id="element-625">
                Capacidad Máxima
              </label>
              <input type="number" min="1" required value={formData.capacity} onChange={e => setFormData({
              ...formData,
              capacity: parseInt(e.target.value)
            })} className="w-full p-3 border-2 border-mist rounded-xl text-sm outline-none focus:border-sage focus:ring-4 focus:ring-sage/10" data-id="element-626" />
            </div>

            <div data-id="element-627">
              <label className="block text-sm font-semibold text-earth mb-2" data-id="element-628">
                Notas Internas
              </label>
              <textarea rows={3} value={formData.notes} onChange={e => setFormData({
              ...formData,
              notes: e.target.value
            })} placeholder="Notas solo visibles para admin..." className="w-full p-3 border-2 border-mist rounded-xl text-sm outline-none focus:border-sage focus:ring-4 focus:ring-sage/10 resize-none" data-id="element-629" />
            </div>
          </form>
        </div>

        <div className="p-6 border-t border-mist bg-sand/10 flex gap-3 justify-end" data-id="element-630">
          <button type="button" onClick={onClose} className="px-6 py-2.5 rounded-xl text-sm font-semibold text-stone hover:bg-mist/30 transition-colors" data-id="element-631">
            Cancelar
          </button>
          <button form="session-form" type="submit" className="px-6 py-2.5 rounded-xl text-sm font-semibold bg-sage text-white hover:bg-sage/90 transition-colors shadow-sm" data-id="element-632">
            Guardar Sesión
          </button>
        </div>
      </motion.div>
    </div>;
}